import { useTheme } from "@emotion/react";
import {
  AccessTimeOutlined,
  AirlineStopsOutlined,
  AlarmOutlined,
  CalendarTodayOutlined,
  ContentCopy,
  PersonAddOutlined,
  PersonOutlineOutlined,
  PersonRemoveOutlined,
  SupportAgentOutlined,
  TimelineOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import {
  Avatar,
  Button,
  Chip,
  CircularProgress,
  Drawer,
  IconButton,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha, Box } from "@mui/system";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChipSla } from "../../../utils/chipsErp/chipSla";
import { StatusIconCard } from "../../../utils/chipsErp/chipStatusCard";
import scrollClicker from "../../../utils/scrollClicker";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import TicketModalContent from "../detailsTicketComponent";
import useStyles from "./styles";

export default function TicketComponent(params) {
  const {
    protocolo = "",
    descricao = "",
    cliente = "",
    dataCadastro = "",
    usuarioAbertura = "",
    status = 1,
    ticketId = "",
    fluxoAtendimento = "",
    getTicketDetails = () => {},
    isEdit = false,
    setSnackbar = () => {},
    selectedCliente = "",
    servicoId = "",
    labelErp = "",
    variantPaper = "elevation",
    allEtapasFluxoAtendimentos = [],
    refreshAtendimentos = () => {},
    percentSla = null,
    historicoFluxoAtendimento = [],
    hiddenTimeLine = false,
    allInfoTicket = {},
    ingressar = () => {},
  } = params;

  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;

  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [usersResponsaveis, setUsersResponsaveis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [ticketDetails, setTicketDetails] = useState({});
  const [joined, setJoined] = useState(false);
  const [openIngressar, setOpenIngressar] = useState(false);
  const [isEditTicket, setIsEditTicket] = useState(false);
  const [isFinishTicket, setIsFinishTicket] = useState(false);
  const [loadingIngressar, setLoadingIngressar] = useState(false);
  const [userIngressado, setUserIngressado] = useState({});
  const [isEditOs, setIsEditOs] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [editedTicket, setEditedTicket] = useState(false); //Necessário para verificar se houve edição no ticket
  const [value, setValue] = useState(0);
  const colors = Object.keys(theme.palette.colors)?.filter(
    (color) => color !== "white" && color !== "black",
  );
  const perfilStorage = JSON.parse(localStorage.getItem("perfil"));
  const userStorage = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    if (allInfoTicket?.usuario_responsavel?.length > 0) {
      const userIngressado = allInfoTicket?.usuario_responsavel?.find(
        (item) =>
          item?.id?.toString() === userStorage?.usuario?.userErpId?.toString(),
      );
      if (userIngressado) {
        setUserIngressado(perfilStorage);
        setJoined(true);
      } else {
        setUserIngressado(null);
        setJoined(false);
      }
    }
    setUsersResponsaveis(allInfoTicket?.usuario_responsavel);
  }, [allInfoTicket?.usuario_responsavel, userStorage?.usuario?.userErpId]);

  function adicionarCores(objetos) {
    return objetos?.reduce((acc, item, index) => {
      acc[item] = colors[index % colors?.length];
      return acc;
    }, {});
  }

  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });

  const statusChamado = {
    aguardando_analise: 1,
    Resolvido: 2,
    resolvido: 2,
    Pendente: 3,
    pendente: 3,

    Cancelado: 4,
    Aberto: 5,
    Encaminhado: 6,
    Agendado: 7,
    "Em Análise": 8,
    Assumido: 9,
    "Em execução": 10,
    Finalizado: 11,
    Deslocamento: 12,
    Reagendar: 13,
    NA: 14,
  };

  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };

  function htmlForText(html) {
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    function extrairTexto(node) {
      let texto = "";

      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          texto += child.textContent;
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const tag = child.tagName;

          switch (tag) {
            case "BR":
              texto += "\n";
              break;
            case "P":
            case "DIV":
              texto += extrairTexto(child) + "\n";
              break;
            case "LI":
              texto += "- " + extrairTexto(child) + "\n";
              break;
            case "UL":
            case "OL":
              texto += extrairTexto(child) + "\n";
              break;
            default:
              texto += extrairTexto(child);
          }
        }
      });

      return texto;
    }

    // Extrai texto e normaliza múltiplas quebras de linha
    const resultado = extrairTexto(tempDiv);
    return resultado.replace(/\n{3,}/g, "\n\n").trim();
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setIsEditOs(false);
    setIsEditTicket(false);
    setIsFinishTicket(false);
  };

  const handleIngressar = async () => {
    const joinedPrev = !joined;

    setJoined(joinedPrev);
    if (joinedPrev) {
      setOpenIngressar(false);
      setLoadingIngressar(true);
      await ingressar(ticketId, userStorage?.usuario?.userErpId, joinedPrev);
      setUserIngressado(perfilStorage);
      setLoadingIngressar(false);
    } else {
      setOpenIngressar(false);
      setLoadingIngressar(true);
      setUserIngressado(null);
      await ingressar(ticketId, userStorage?.usuario?.userErpId, joinedPrev);
      setLoadingIngressar(false);
    }
  };

  const handleCancelIngressar = () => {
    setOpenIngressar(false);
  };

  const handleOpen = async () => {
    setOpen(true);
    setLoading(true);
    const response = await getTicketDetails(ticketId);

    setTicketDetails(response || {});
    setItensPublic((prev) => {
      const mensagens = [];
      const anexos = [];
      const anexosCliente = [];
      const rfo = [];
      for (const item of response?.itensTicketPublic || []) {
        if (item?.itemType === "mensagem") {
          mensagens.push(item?.itemId);
        } else if (item?.itemType === "anexo") {
          anexos?.push(item?.itemId);
        } else if (item?.itemType === "anexoCliente") {
          anexosCliente?.push(item?.itemId);
        } else if (item?.itemType === "rfo") {
          rfo?.push(item?.itemId);
        }
      }

      return {
        ...prev,
        mensagens,
        anexos,
        anexosCliente,
        rfo,
      };
    });

    setLoading(false);
  };
  const handleClose = () => {
    setOpen(false);
    setIsEditTicket(false);
    setIsFinishTicket(false);
    setIsEditOs(false);
    setIsNewOs(false);
    setConfirmacaoSaidaPagina(false);
    setValue(0);
    if (editedTicket) {
      refreshAtendimentos();
      setEditedTicket(false);
    }
  };

  const formatTotalTime = (historyArray) => {
    // 1. Soma todos os minutos do array
    const totalMinutes =
      historyArray?.reduce((acc, item) => acc + (item.timeEtapa || 0), 0) || 0;

    if (totalMinutes === 0) return "0 min";

    // Constantes de conversão
    const MIN_IN_HOUR = 60;
    const MIN_IN_DAY = 1440; // 60 * 24
    const MIN_IN_YEAR = 525600; // 1440 * 365

    let remaining = totalMinutes;

    const years = Math.floor(remaining / MIN_IN_YEAR);
    remaining %= MIN_IN_YEAR;

    const days = Math.floor(remaining / MIN_IN_DAY);
    remaining %= MIN_IN_DAY;

    const hours = Math.floor(remaining / MIN_IN_HOUR);
    const minutes = remaining % MIN_IN_HOUR;

    // 2. Monta a string de forma amigável
    const parts = [];
    if (years > 0) parts.push(`${years} ${years === 1 ? "ano" : "anos"}`);
    if (days > 0) parts.push(`${days} ${days === 1 ? "dia" : "dias"}`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || parts.length === 0) parts.push(`${minutes}min`);

    return parts.join(" ");
  };

  const fluxoAtendimentoColor = adicionarCores(allEtapasFluxoAtendimentos);

  const convertStatusVoalle = {
    1: "Aguardando Análise",
    2: "Resolvido",
    3: "Pendente",
    4: "Cancelado",
  };
  function converterMinutos(totalMinutos) {
    if (!totalMinutos)
      return {
        text: "Menos de 1 minuto",
        hora: 0,
        minuto: 0,
      };
    const horas = Math.floor(totalMinutos / 60);
    const minutos = totalMinutos % 60;

    return { text: `${horas}h ${minutos}m`, hora: horas, minuto: minutos };
  }

  const getStatusColor = (value) => {
    if (value === 100) {
      return theme.palette.chip.main.completed;
    }

    if (value >= 80) {
      return theme.palette.colors.yellow.darker;
    }

    if (value >= 50) {
      return theme.palette.chip.main.inProgress;
    }

    if (value >= 0 && value !== null) {
      return theme.palette.chip.main.waitingReturn;
    }

    if (value < 0) {
      return theme.palette.chip.main.pending;
    }

    return "transparent"; // Valor padrão caso receba algo inesperado
  };
  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };
  const customTooltip = (
    <Box sx={styles.containerCustomTooltip}>
      <Box sx={styles.boxCustomTooltip}>
        <Typography sx={styles.titleCustomTooltip}>
          Histórico do ticket
        </Typography>
        <Box sx={styles.boxChip}>
          <Box variant="outlined" sx={styles.chipTime}>
            <AccessTimeOutlined sx={{ fontSize: "16px " }} />
            <Typography
              variant="caption"
              sx={{ fontWeight: 600, color: theme.palette.white.main }}
            >
              Tempo total: {formatTotalTime(historicoFluxoAtendimento)}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Paper
        variant="outlined"
        sx={{
          p: 1,
          backgroundColor:
            theme.palette.mode === "dark"
              ? alpha(theme.palette.colors.black.dark, 0.4)
              : theme.palette.colors.black.lighter,
        }}
      >
        <Box sx={styles.containerTimeline}>
          {historicoFluxoAtendimento?.map((item, index) => (
            <>
              <Paper variant="outlined" sx={styles.paperTimeline} key={index}>
                <Box
                  sx={{
                    ...styles.boxTimeline,
                    backgroundColor:
                      theme.palette.colors[
                        fluxoAtendimentoColor[item?.descricaoEtapa]
                      ].medium,
                  }}
                />
                <Box sx={{ marginLeft: "10px" }}>
                  <Typography sx={styles.titleEtapa}>
                    {item?.descricaoEtapa}
                  </Typography>

                  <Typography sx={{ fontSize: "12px" }}>
                    <Box component="span" sx={{ fontWeight: "bold" }}>
                      De:
                    </Box>{" "}
                    {dayjs(item?.initialDate).format("DD/MM/YY HH:mm")}
                  </Typography>

                  <Typography sx={{ fontSize: "12px" }}>
                    <Box component="span" sx={{ fontWeight: "bold" }}>
                      Até:
                    </Box>{" "}
                    {index === historicoFluxoAtendimento?.length - 1 &&
                    status !== "Resolvido"
                      ? "Atualmente"
                      : dayjs(item?.finalDate).format("DD/MM/YY HH:mm")}
                  </Typography>

                  <Typography sx={{ fontSize: "12px" }}>
                    <Box component="span" sx={{ fontWeight: "bold" }}>
                      Tempo na etapa:
                    </Box>{" "}
                    {converterMinutos(item?.timeEtapa)?.text}
                  </Typography>
                </Box>
              </Paper>
            </>
          ))}
        </Box>
      </Paper>
    </Box>
  );

  return (
    <Paper
      elevation={theme.palette.mode == "dark" ? 0 : 3}
      variant={variantPaper}
      sx={styles.paperContainer}
    >
      {StatusIconCard([statusChamado[status]])}
      {erp === "HUBSOFT" &&
        historicoFluxoAtendimento?.length > 0 &&
        !hiddenTimeLine && (
          <Tooltip
            placement="right"
            arrow
            title={
              !open && historicoFluxoAtendimento?.length > 0
                ? customTooltip
                : ""
            }
            // Mantém aberto enquanto o mouse estiver sobre o conteúdo do Tooltip
            componentsProps={{
              tooltip: {
                onMouseEnter: () => setIsHovered(true),
                onMouseLeave: () => setIsHovered(false),
              },
            }}
          >
            <Box
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              sx={{
                ...styles.boxHistorico,
                width: isHovered ? 100 : 30, // Controlado pelo estado

                // O texto agora reage ao estado isHovered
                "& .texto-historico": {
                  opacity: isHovered ? 1 : 0,
                  transition: "opacity 0.3s ease-in-out",
                  marginLeft: "10px",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TimelineOutlined sx={{ fontSize: "15px", minWidth: "15px" }} />
              <Typography
                className="texto-historico"
                sx={{ fontSize: "12px", fontWeight: 500 }}
              >
                Histórico
              </Typography>
            </Box>
          </Tooltip>
        )}
      <Box sx={styles.containerHeader}>
        <Box sx={styles.boxProtocolo}>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "bold",

              color:
                theme.palette.mode === "dark"
                  ? theme.palette.colors.black.light
                  : theme.palette.colors.black.medium,
            }}
          >
            {" "}
            Protocolo:
          </Typography>
          <Typography
            sx={{
              ...styles.titleProtocolo,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {protocolo}
          </Typography>

          <Tooltip title="Clique para copiar">
            <IconButton
              size="small"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(protocolo);
                } catch (err) {
                  // Fallback para navegadores mais antigos ou sem permissão
                  const textArea = document.createElement("textarea");
                  textArea.value = protocolo;
                  document.body.appendChild(textArea);
                  textArea.select();
                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Falha ao copiar texto: ", err);
                  }
                  document.body.removeChild(textArea);
                }
                setSnackbar({
                  children: "Campo copiado!",
                  severity: "info",
                });
              }}
            >
              <ContentCopy sx={{ fontSize: "15px" }} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={styles.boxProtocolo}>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.colors.black.light
                  : theme.palette.colors.black.medium,
            }}
          >
            {" "}
            {labelErp} ID:
          </Typography>
          <Typography
            sx={{
              ...styles.titleProtocolo,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {servicoId}
          </Typography>

          <Tooltip title="Clique para copiar">
            <IconButton
              size="small"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(servicoId);
                } catch (err) {
                  // Fallback para navegadores mais antigos ou sem permissão
                  const textArea = document.createElement("textarea");
                  textArea.value = servicoId;
                  document.body.appendChild(textArea);
                  textArea.select();
                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Falha ao copiar texto: ", err);
                  }
                  document.body.removeChild(textArea);
                }
                setSnackbar({
                  children: "Campo copiado!",
                  severity: "info",
                });
              }}
            >
              <ContentCopy sx={{ fontSize: "15px" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={styles.containerDescription}>
        <Typography sx={styles.description}>
          {(erp === "HUBSOFT" && descricao) ||
            (erp === "VOALLE" && htmlForText(descricao)) ||
            (erp === "IXC" && descricao)}
        </Typography>
      </Box>
      <Box sx={styles.boxInfos}>
        <Tooltip title={cliente}>
          <Box
            sx={{
              ...styles.containerInfo,
              cursor: "pointer",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            onClick={() => {
              if (selectedCliente?.id) {
                const clienteFilterData = JSON.parse(
                  localStorage.getItem("filterData"),
                );

                let clientStorage = clienteFilterData;
                if (clienteFilterData?.clienteId !== selectedCliente?.id) {
                  clientStorage = {
                    interfaceId: "",
                    clienteId: selectedCliente?.id,
                    hostId: "",
                    selectTime: 5,
                    initialDate: "",
                    finalDate: "",
                  };
                }
                localStorage.setItem(
                  "filterData",
                  JSON.stringify(clientStorage),
                );
                navigate(
                  `/interno/home/perfil/servicos/${selectedCliente?.id}`,
                );
              } else {
                setSnackbar({
                  children: "Cliente não cadastrado no sistema",
                  severity: "warning",
                });
              }
            }}
            onMouseDown={(e) => {
              if (selectedCliente?.id) {
                const clienteFilterData = JSON.parse(
                  localStorage.getItem("filterData"),
                );

                let clientStorage = clienteFilterData;
                if (clienteFilterData?.clienteId !== selectedCliente?.id) {
                  clientStorage = {
                    interfaceId: "",
                    clienteId: selectedCliente?.id,
                    hostId: "",
                    selectTime: 5,
                    initialDate: "",
                    finalDate: "",
                  };
                }
                localStorage.setItem(
                  "filterData",
                  JSON.stringify(clientStorage),
                );
                scrollClicker(
                  e,
                  false,
                  `/interno/home/perfil/servicos/${selectedCliente?.id}`,
                );
              } else {
                setSnackbar({
                  children: "Cliente não cadastrado no sistema",
                  severity: "warning",
                });
              }
            }}
          >
            <PersonOutlineOutlined
              sx={{
                ...styles.icon,
                color:
                  theme.palette.mode == "dark"
                    ? theme.palette.colors.black.light
                    : theme.palette.colors.black.medium,
              }}
            />{" "}
            <Typography sx={styles.cardDescricao}>{cliente}</Typography>
          </Box>
        </Tooltip>
        <Box sx={styles.containerInfo}>
          <Box sx={styles.containerInfo}>
            <CalendarTodayOutlined
              sx={{
                ...styles.icon,
                color:
                  theme.palette.mode == "dark"
                    ? theme.palette.colors.black.light
                    : theme.palette.colors.black.medium,
                fontSize: "18px",
              }}
            />{" "}
            <Typography sx={styles.cardDescricao}>{dataCadastro}</Typography>
          </Box>
          {percentSla && (
            <Box sx={styles.containerInfo}>
              <AlarmOutlined
                sx={{
                  ...styles.icon,
                  color:
                    theme.palette.mode == "dark"
                      ? theme.palette.colors.black.light
                      : theme.palette.colors.black.medium,
                  fontSize: "18px",
                }}
              />{" "}
              <Tooltip
                title={
                  <Box sx={styles.boxTooltip}>
                    <Typography sx={styles.descriptionTooltip}>
                      SLA da etapa do atendimento
                    </Typography>
                    <Box sx={styles.containerTooltip}>
                      <Typography sx={styles.descriptionTooltip}>
                        Tempo na etapa:
                      </Typography>
                      <Box
                        sx={{
                          backgroundColor: getStatusColor(
                            allInfoTicket?.percentSla,
                          ),
                          padding: "2px 6px",
                          borderRadius: "5px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color: theme.palette.white.main,
                            fontSize: "12px",
                          }}
                        >
                          {converterMinutos(allInfoTicket?.timeSla)?.text}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                }
              >
                {ChipSla(percentSla)}
              </Tooltip>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            ...styles.containerInfo,
            display: "flex",
            alignItems: "center",
            minWidth: 0,
          }}
        >
          <SupportAgentOutlined
            sx={{
              ...styles.icon,
              flexShrink: 0, // Garante que o ícone não mude de tamanho
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          />

          <Tooltip
            title={
              usersResponsaveis?.length > 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    padding: "4px",
                  }}
                >
                  {usersResponsaveis.map((u, index) => (
                    <Typography
                      key={u.id || index}
                      variant="caption"
                      sx={{
                        display: "block",
                        whiteSpace: "normal", // Permite a quebra de linha natural
                        wordBreak: "break-word",
                      }}
                    >
                      • {u.name}
                    </Typography>
                  ))}
                </Box>
              ) : (
                ""
              )
            }
            arrow
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: 0,
                flex: 1,
              }}
            >
              <Typography
                noWrap
                sx={{
                  ...styles.cardDescricao,
                  fontWeight: "bold",
                  minWidth: 0, // Reforça o truncamento
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : theme.palette.tertiary.main,
                }}
              >
                {usersResponsaveis?.[0]?.name || "Sem responsável"}
              </Typography>

              {usersResponsaveis?.length > 1 && (
                <Chip
                  label={`+${usersResponsaveis.length - 1}`}
                  size="small"
                  sx={{
                    fontWeight: "bold",
                    flexShrink: 0,
                    height: 20,
                    fontSize: "0.75rem",
                    backgroundColor: "primary.main",
                    color: "primary.contrastText",
                  }}
                />
              )}
            </Box>
          </Tooltip>
        </Box>
        <Box sx={styles.containerInfo}>
          {fluxoAtendimento && (
            <Box sx={styles.containerInfo}>
              <AirlineStopsOutlined
                sx={{
                  ...styles.icon,
                  color:
                    theme.palette.mode == "dark"
                      ? theme.palette.colors.black.light
                      : theme.palette.colors.black.medium,
                }}
              />
              <Tooltip title={fluxoAtendimento}>
                <Chip
                  size="small"
                  label={fluxoAtendimento}
                  sx={{
                    ...styles.chipFLuxoAtendimento,
                    backgroundColor:
                      theme.palette.mode == "dark"
                        ? theme.palette.colors[
                            fluxoAtendimentoColor[fluxoAtendimento]
                          ]?.darker
                        : theme.palette.colors[
                            fluxoAtendimentoColor[fluxoAtendimento]
                          ]?.medium,
                  }}
                />
              </Tooltip>
            </Box>
          )}
        </Box>
        <Box sx={styles.containerButton}>
          {/* Botão de Detalhes (ajustado para dar espaço) */}
          <Button
            onClick={handleOpen}
            sx={styles.buttonDetails}
            startIcon={<VisibilityOutlined />}
            variant="outlined"
            size="small"
          >
            Ver detalhes
          </Button>

          <Box sx={styles.joinActionArea}>
            {loadingIngressar ? (
              <CircularProgress size={20} />
            ) : joined && userStorage?.usuario?.userErpId ? (
              <Tooltip title={"Desvincular do ticket"}>
                <IconButton
                  onClick={() => setOpenIngressar(true)}
                  disabled={status === "resolvido"}
                  sx={{ padding: 0 }}
                >
                  <Box sx={styles.avatarWrapper}>
                    <Avatar
                      src={userIngressado?.foto}
                      sx={styles.smallAvatar}
                    />
                    <Box sx={styles.badgeRemove}>
                      <PersonRemoveOutlined
                        sx={{ fontSize: 12, color: "#fff" }}
                      />
                    </Box>
                  </Box>
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title={"Ingressar no ticket"}>
                <IconButton
                  onClick={() => setOpenIngressar(true)}
                  sx={styles.joinButton}
                  size="small"
                  disabled={status === "resolvido"}
                >
                  <PersonAddOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Box>
      </Box>
      <TicketModalContent
        open={open}
        loading={loading}
        handleClose={handleClose}
        erp={erp}
        ticketDetails={ticketDetails}
        convertStatusVoalle={convertStatusVoalle}
        status={statusChamado[status]}
        labelTabsErp={labelTabsErp}
        value={value}
        handleChange={handleChange}
        isEdit={isEdit}
        setTicketDetails={setTicketDetails}
        itensPublic={itensPublic}
        setItensPublic={setItensPublic}
        setSnackbar={setSnackbar}
        fluxoAtendimentoColor={fluxoAtendimentoColor}
        setEditedTicket={setEditedTicket}
        historicoFluxoAtendimento={historicoFluxoAtendimento}
        setIsEditTicket={setIsEditTicket}
        isEditTicket={isEditTicket}
        setIsFinishTicket={setIsFinishTicket}
        isFinishTicket={isFinishTicket}
        isEditOs={isEditOs}
        setIsEditOs={setIsEditOs}
        setIsNewOs={setIsNewOs}
        isNewOs={isNewOs}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={openIngressar}
        confirmLoad={false}
        setOpenConfirmacao={setOpenIngressar}
        execute={handleIngressar}
        cancel={handleCancelIngressar}
        severity={!joined ? "info" : "warning"}
        title={"Atenção"}
        contentText={""}
        headerText={
          !joined
            ? "Você está prestes a ingressar no ticket. Deseja continuar?"
            : "Você está prestes a se desvincular do ticket. Deseja continuar?"
        }
        confirmText={!joined ? "Ingressar" : "Desvincular"}
      />
    </Paper>
  );
}
